import ENDPOINTS from 'api/endpoints';
import { doDelete, doGet, doPost } from 'api/request';
import { LOGGER_TYPE } from 'api/types';
import { generateNextPath } from 'lib/routeHelper';
import type { ApiKey, ApiKeysCreateRequest } from './types';

export const getApiKeys = (accountId: string) => {
  return doGet<ApiKey[]>(
    generateNextPath(ENDPOINTS.API_KEYS, { accountId }),
    LOGGER_TYPE.JUPITER,
    {
      prefix: 'nebula',
    },
  );
};

export const postApiKey = (accountId: string, body: ApiKeysCreateRequest) => {
  return doPost<ApiKey>(
    generateNextPath(ENDPOINTS.API_KEYS, { accountId }),
    LOGGER_TYPE.JUPITER,
    body,
    { prefix: 'nebula' },
  );
};

export const deleteApiKey = (accountId: string, apiKeyId: string) => {
  return doDelete<void>(
    generateNextPath(ENDPOINTS.API_KEYS, { accountId }),
    LOGGER_TYPE.JUPITER,
    {},
    {
      additionalHeaders: { 'X-API-KEY': apiKeyId },
      prefix: 'nebula',
    },
  );
};
